import { StyleSheet, Text } from '@react-pdf/renderer'
import PDFBorderedList from '@/components/ReportPDF/PDFBorderedList'
import PDFPage from '@/components/ReportPDF/PDFPage'
import baseStyles from '@/components/ReportPDF/styles'
import moment from 'moment'
import { DATE_FORMAT_CN } from '@/libs/core/constants'

const styles = StyleSheet.create({ listText: { flex: 1 }, ...baseStyles })

const DisclaimerPage = ({ reportData }) => {
  const {
    firstPartyAbbreviation,
    firstPartyFullName,
    secondPartyAbbreviation,
    secondPartyFullName,
    version,
    reportDate,
  } = reportData || {}

  return (
    <PDFPage reportData={reportData}>
      <Text style={[baseStyles.title, { marginBottom: 40 }]}>法律聲明</Text>
      <Text style={{ marginBottom: 40 }}>
        此分文件內含機密及版權所有的資訊。僅供
        <Text style={styles.primaryText}>{firstPartyAbbreviation}</Text>
        使用。嚴禁未經授權者使用或複製本文件。
      </Text>
      <Text style={{ marginBottom: 40 }}>
        本測試是由
        <Text style={styles.primaryText}>{secondPartyAbbreviation}</Text>
        的資訊安全專家所執行。
        <Text style={styles.primaryText}>{secondPartyAbbreviation}</Text>
        保證此分文件的內容正確且可經由網路做驗證。
      </Text>

      <Text style={{ fontWeight: 'bold', marginBottom: 10 }}>關於本文件</Text>
      <PDFBorderedList
        name={'docinfo'}
        items={[
          <>
            <Text style={[styles.listText, { fontWeight: 'bold' }]}>文件類別</Text>
            <Text style={styles.listText}>資訊安全教育訓練結果及分析報告書</Text>
          </>,
          <>
            <Text style={[styles.listText, { fontWeight: 'bold' }]}>客戶</Text>
            <Text style={[styles.listText, styles.primaryText]}>{firstPartyFullName}</Text>
          </>,
          <>
            <Text style={[styles.listText, { fontWeight: 'bold' }]}>執行顧問</Text>
            <Text style={[styles.listText, styles.primaryText]}>{secondPartyFullName}</Text>
          </>,
          <>
            <Text style={[styles.listText, { fontWeight: 'bold' }]}>文件版本</Text>
            <Text style={[styles.listText, styles.primaryText]}>{version}</Text>
          </>,
          <>
            <Text style={[styles.listText, { fontWeight: 'bold' }]}>製作日期</Text>
            <Text style={[styles.listText, styles.primaryText]}>
              {moment(reportDate).format(DATE_FORMAT_CN)}
            </Text>
          </>,
        ]}
      />
    </PDFPage>
  )
}

export default DisclaimerPage
